import { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { languageService } from 'js/services/language.service';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetTermsConditions = () => {
    const send = useGenericSend();
    const lang = useUserSelector(prop('lang'));
    const {
        casinoName,
        clientType,
        clientSkin
    } = useAppSelector(pick(['casinoName', 'clientType', 'clientSkin']));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    return useCallback(
        async (request: Types.IGetTermsAndConditionsFileRequestData = {}):
        Promise<Types.IGetTermsAndConditionsFileResponseData> => {
            const {
                data
            } = await send<Types.IGetTermsAndConditionsFileRequestData, Types.IGetTermsAndConditionsFileResponseData>({
                ID: 35595,
                responses: [35596, 35597],
                description: 'Get Terms And Conditions File',
                clientType,
                casinoName,
                clientPlatform,
                skin: clientSkin,
                stringFormat: true,
                contentType: 'html',
                language: lang && languageService.convertToIMS(lang).toUpperCase() || '',
                ...request
            });

            return data;
        }, [send, clientType, casinoName, clientSkin, clientPlatform, lang]);
};
